import { BasicInsuranceModelType, BasicInsurancePlanType } from '../api';

export function getPlanForModel(model: BasicInsuranceModelType): BasicInsurancePlanType {
  switch (model) {
    case 'CASA_NOVA':
    case 'MANAGED_CARE':
    case 'MED_DIRECT':
      return 'GENERAL_PRACTITIONER_PLAN';
    case 'MED_CALL':
    case 'TEL_CARE':
    case 'TEL_DOC':
      return 'TELEPHONE_PLAN';
    case 'COMBI_CARE':
      return 'COMBINATION_PLAN';
    case 'TRADITIONAL':
      return 'TRADITIONAL_PLAN';
    case 'VIVA':
      return 'INTEGRATED_CARE_PLAN';
  }
}
